import { useState } from "react";
import { ActionFunctionArgs, data, Outlet, useLoaderData } from "react-router";

import { FeaturesContext, PortalContainerContext } from "@/contexts";
import { FeatureFlags } from "@/types";

export async function loader() {
  const featureFlagsResponse = await fetch(`/api/client/features/`);

  if (featureFlagsResponse.status !== 200) {
    throw data("Failed to load the user feature flags", {
      status: featureFlagsResponse.status,
    });
  }

  const { data: featureFlags } = (await featureFlagsResponse.json()) as {
    data: FeatureFlags;
  };

  return {
    featureFlags,
  };
}

export async function action({ request }: ActionFunctionArgs) {
  if (request.method === "DELETE") {
    // Get CSRF token from meta tag (needed for anything not GET)
    const csrfToken = document?.querySelector<HTMLMetaElement>(
      'meta[name="csrf-token"]'
    )?.content;

    const response = await fetch("/users/sign_out/", {
      method: "delete",
      headers: {
        "X-CSRF-Token": `${csrfToken}`,
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (response.status === 204) {
      window.location.href = "/users/sign_in";
    }
  }
}

function Root() {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const { featureFlags } = useLoaderData<typeof loader>();

  return (
    <PortalContainerContext value={{ container }}>
      <FeaturesContext value={{ featureFlags }}>
        <Outlet />
        <div className="relative z-50" ref={setContainer} />
      </FeaturesContext>
    </PortalContainerContext>
  );
}

export default Root;
